import { useTranslation } from "react-i18next";
import { KPICard } from "@/components/admin/shared/KPICard";
import { Truck, Clock, CheckCircle, XCircle } from "lucide-react";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface YangoCostSummaryProps {
  readonly totalDispatches: number;
  readonly totalCostFcfa: number;
  readonly pendingCount: number;
  readonly inTransitCount: number;
  readonly deliveredCount: number;
  readonly failedCount: number;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function YangoCostSummary({
  totalDispatches,
  totalCostFcfa,
  pendingCount,
  inTransitCount,
  deliveredCount,
  failedCount,
}: YangoCostSummaryProps) {
  const { t } = useTranslation("logistics");

  const avgCost =
    deliveredCount > 0 ? Math.round(totalCostFcfa / deliveredCount) : 0;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      <KPICard
        label={t("yango.kpi.total_dispatches")}
        value={totalDispatches}
        format="number"
        icon={<Truck className="h-4 w-4" />}
      />
      <KPICard
        label={t("yango.kpi.total_cost")}
        value={totalCostFcfa}
        format="currency"
        icon={<Truck className="h-4 w-4" />}
      />
      <KPICard
        label={t("yango.kpi.avg_cost")}
        value={avgCost}
        format="currency"
        icon={<Truck className="h-4 w-4" />}
      />
      <KPICard
        label={t("yango.kpi.pending")}
        value={pendingCount + inTransitCount}
        format="number"
        icon={<Clock className="h-4 w-4" />}
      />
      <KPICard
        label={t("yango.kpi.delivered")}
        value={deliveredCount}
        format="number"
        icon={<CheckCircle className="h-4 w-4" />}
      />
      <KPICard
        label={t("yango.kpi.failed")}
        value={failedCount}
        format="number"
        icon={<XCircle className="h-4 w-4" />}
      />
    </div>
  );
}
